import {Navigate, Route, Routes} from "react-router-dom";
import {routes} from "./routes";
import {route} from "../types/global.types";

const RoutesComponent = () => {
    return (
        <Routes>
            {routes.map((item: route) => (
                <Route
                    key={item.id}
                    element={item.component && <item.component />}
                    path={item.path}
                >
                    {item.child &&
                        item.child.map((child) => (
                            <Route
                                key={child.id}
                                path={child.path}
                                element={child.component && <child.component />}
                            >
                                {child.child &&
                                    child.child.map((child) => (
                                        <Route
                                            key={child.id}
                                            path={child.path}
                                            element={child.component && <child.component />}
                                        />
                                    ))}
                            </Route>
                        ))}
                </Route>
            ))}
            {/* <Route path="" element={<Navigate to="/" replace />} /> */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}

export default RoutesComponent;